import { CheckNotes, InspectionCase } from '../../inspection-cases';
import {
  InspectionPercentageCase,
  InspectionPercentageCaseDto
} from '../../inspection-cases/inspection-percentage-case.dto';

export class ClosedFoamSpraySystemsDto extends InspectionCase {
  venturiFlowMeterInstallation?: InspectionCase;
  flowRateAsDesigned?: InspectionCase;
  foamSampling?: InspectionCase;
  waterCheck?: InspectionCase;
  concentrateFoamfromStorageVessels?: InspectionCase;
  foamConcentrationResults?: InspectionPercentageCaseDto;
}

export class ClosedFoamSpraySystems extends ClosedFoamSpraySystemsDto {
  constructor(
    data: ClosedFoamSpraySystemsDto = { title: 'מערכות מתזים סגורות בקצף' }
  ) {
    super(data);
    this.venturiFlowMeterInstallation = new InspectionCase({
      ...data.venturiFlowMeterInstallation,
      title: `וודא התקנת של מד ספיקה ונטורי על ברז הבדיקה המיועד לביצוע סימולציה בספיקות המתוכננות`
    });
    this.flowRateAsDesigned = new InspectionCase({
      ...data.flowRateAsDesigned,
      title: `כוון את הספיקה ע"י פתיחת מגוף ברז הבדיקה המיועד עד לקבלת הספיקות המתוכננות`
    });
    this.foamSampling = new InspectionCase({
      ...data.foamSampling,
      title: `בקבלת קצף לצורך איסוף דגימה , אסוף קצף דגימה מתמיסת הפרימיקס מברז בדיקה ייעודי רק לאחר הזרמה של דקה. יש לאסוף כמות של 300 סמ"ק לפחות`
    });
    this.waterCheck = new InspectionCase({
      ...data.waterCheck,
      title: `יש לאסוף כמות מים של לפחות ליטר וחצי בכלי מתאים. את המים יש לקחת מקו הכיבוי לפני  מרכז הקצף`
    });
    this.concentrateFoamfromStorageVessels = new InspectionCase({
      ...data.concentrateFoamfromStorageVessels,
      title: `יש לאסוף בכלי כמות של לפחות 10 סמ"ק של תרכיז הקצף מכלי האגירה בשטח `
    });
    this.foamConcentrationResults = new InspectionPercentageCase({
      ...data.foamConcentrationResults,
      title: `יש לבצע בדיקת ריכוזים בהתאם לנוהל מס':10-07-00 - האם התקבלו ריכוזי קצף בהתאם לדרישות התקן ודרישות התכנון - ציין את ריכוז הקצף שהתקבל`
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      ((!this.venturiFlowMeterInstallation.isApplicable ||
        this.venturiFlowMeterInstallation.isPassed) &&
        (!this.flowRateAsDesigned.isApplicable ||
          this.flowRateAsDesigned.isPassed) &&
        (!this.foamSampling.isApplicable || this.foamSampling.isPassed) &&
        (!this.waterCheck.isApplicable || this.waterCheck.isPassed) &&
        (!this.concentrateFoamfromStorageVessels.isApplicable ||
          this.concentrateFoamfromStorageVessels.isPassed) &&
        (!this.foamConcentrationResults.isApplicable ||
          this.foamConcentrationResults.isPassed));
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [
      ...this.venturiFlowMeterInstallation.getNotes(),
      ...this.flowRateAsDesigned.getNotes(),
      ...this.foamSampling.getNotes(),
      ...this.waterCheck.getNotes(),
      ...this.concentrateFoamfromStorageVessels.getNotes(),
      ...this.foamConcentrationResults.getNotes()
    ];
  }
}
